import { BackArrow } from "assets/icons";
import Button from "components/BaseWidgets/button";
import { useNavigate } from "react-router-dom";

function Header({ managePhotoView = false, setManagedPhoto }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-start gap-3">
      <Button
        variant="custom"
        height={24}
        onClick={() => {
          managePhotoView ? setManagedPhoto(false) : navigate(-1);
        }}
      >
        <BackArrow />
      </Button>
      <div className="flex flex-col gap-1">
        <h1 className="font-title-lg fw-700 leading-3">Manage your photo</h1>
        <p className="font-body-md2">
          Press and drag the photo you want to set as your primary photo.
        </p>
      </div>
    </div>
  );
}

export default Header;
